export function validationTransactionBatch (transaction) {
    const result = {
        success: false,
        message: ""
    }
    if(isNaN(transaction.qty) || transaction.qty <= 0) {
        result.message = "please write valid quantitiy";
        return result;
    }
    if (!["IN", "OUT", "ADJUSTMENT"].includes(transaction.transactionType?.toUpperCase())) {
    result.message = "please choose valid type of transaction";
    return result;
    }
    if(!["G", "piece"].includes(transaction.unit)) {
        result.message = "please choose valid unit";
        return result;
    }

    result.success = true;
    return result;
} 